// all variables
const selectors = {
  displayButton: '.cartStockist__resultHeaderIcon',
  errorApiMessage: 'Sorry, our stockist finder is currently unavailable, please try again later.',
  errorAutocomplete: 'Sorry, please select a place from the list',
  errorBrowserGeolocation: 'geolocation is not supported by this browser.',
  errorGeolocation: 'Sorry, you need to enable location sharing',
  errorGeometry: 'Sorry, please select a place from the list',
  errorMessage: 'Sorry, we couldnt find any stockist near that location.',
  findStockistsButton: '#find-stockists-btn',
  form: '.cartStockist__contentForm',
  geoLocationTitle: 'Current Location',
  mapWrapper: '#map',
  pacError: '#pac-error',
  pacInput: '#pac-input',
  pacInputIcon: '.cartStockist__contentFormInputIcon',
  pacMessage: '#pac-message',
  result: '.cartStockist__result',
  resultList: '.cartStockist__resultList',
  resultListCard: '.cartStockist__resultListCard',
  selectedProductButton: '.cartStockist__resultSelectedButton',
  selectedProductLink: '.cartStockist__resultSelectedLink',
  selectedProductWrapper: '.cartStockist__resultSelected',
  stockist: '.cartStockist',
  stockistCount: '.cartStockist__resultHeaderTitleCount',

  pacInputIconActiveClass: 'cartStockist__contentFormInputIcon--active',
  resultActiveClass: 'cartStockist__result--active',
  resultClass: 'cartStockist__result',
  resultListCardActiveClass: 'cartStockist__resultListCard--active',
  resultListCardClass: 'cartStockist__resultListCard',
  resultListCardCountClass: 'cartStockist__resultListCardCount',
  resultLoadingClass: 'cartStockist__result--loading',
  selectedProductWrapperActiveClass: 'cartStockist__resultSelected--active',
  stockistErrorClass: 'cartStockist--error',
  stockistListClass: 'cartStockist--list',
  stockistMapClass: 'cartStockist--map'
};

// style for map
const mapStyle = [
  {
    "featureType": "administrative.land_parcel",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "administrative.neighborhood",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi.business",
    "stylers": [
      {
        "visibility": "on"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels.text",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "on"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "labels.text",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  }
];

// marker svg for map
const userpin = "//peckishbirdfood.com/cdn/shop/t/50/assets/UserPin.svg?v=182295692398498335371788865330",
      stockistPins = ["//peckishbirdfood.com/cdn/shop/t/50/assets/StockistPin1_active.svg?v=123983842772871769331788865327",
                      "//peckishbirdfood.com/cdn/shop/t/50/assets/StockistPin2_active.svg?v=178268812861316750101788865327",
                      "//peckishbirdfood.com/cdn/shop/t/50/assets/StockistPin3_active.svg?v=130149272480715532181788865328",
                      "//peckishbirdfood.com/cdn/shop/t/50/assets/StockistPin4_active.svg?v=115824940120300791821788865329",
                      "//peckishbirdfood.com/cdn/shop/t/50/assets/StockistPin5_active.svg?v=105877324071340759641788865330",
                      "//peckishbirdfood.com/cdn/shop/t/50/assets/StockistPin6_active.svg?v=162670111389989011481788865327",
                      "//peckishbirdfood.com/cdn/shop/t/50/assets/StockistPin7_active.svg?v=13393962131205136741788865328",
                      "//peckishbirdfood.com/cdn/shop/t/50/assets/StockistPin8_active.svg?v=86351970546780298231788865328",
                      "//peckishbirdfood.com/cdn/shop/t/50/assets/StockistPin9_active.svg?v=38452149671300449621788865329",
                      "//peckishbirdfood.com/cdn/shop/t/50/assets/StockistPin10_active.svg?v=89187627307166769151788865330"
                     ],
      stockistPinsSelected = ["//peckishbirdfood.com/cdn/shop/t/50/assets/StockistPin1_selected.svg?v=45438530574583735591788865327",
                              "//peckishbirdfood.com/cdn/shop/t/50/assets/StockistPin2_selected.svg?v=109644984202603755361788865328",
                              "//peckishbirdfood.com/cdn/shop/t/50/assets/StockistPin3_selected.svg?v=169293627329200945241788865329",
                              "//peckishbirdfood.com/cdn/shop/t/50/assets/StockistPin4_selected.svg?v=142052924770609829191788865329",
                              "//peckishbirdfood.com/cdn/shop/t/50/assets/StockistPin5_selected.svg?v=123270734115504579411788865330",
                              "//peckishbirdfood.com/cdn/shop/t/50/assets/StockistPin6_selected.svg?v=89055747213279525461788865327",
                              "//peckishbirdfood.com/cdn/shop/t/50/assets/StockistPin7_selected.svg?v=154546342891381360481788865328",
                              "//peckishbirdfood.com/cdn/shop/t/50/assets/StockistPin8_selected.svg?v=181389529130229257791788865329",
                              "//peckishbirdfood.com/cdn/shop/t/50/assets/StockistPin9_selected.svg?v=1454328504878480991788865329",
                              "//peckishbirdfood.com/cdn/shop/t/50/assets/StockistPin10_selected.svg?v=141710344332465250121788865330"
                             ];

// declare element which will be changed
let userMap, userPlace, userOriginMarker, userInfoWindow, userSelectedMarker, userAutocomplete, userLocation,
    [userMarkers, userStockists] = [[], []];

// declarate dom element
const displayButton = document.querySelectorAll(selectors.displayButton),
      findStockistsButton = document.querySelector(selectors.findStockistsButton),
      form = document.querySelector(selectors.form),
      mapWrapper = document.querySelector(selectors.mapWrapper),
      pacError = document.querySelector(selectors.pacError),
      pacInput = document.querySelector(selectors.pacInput),
      pacInputIcon = document.querySelector(selectors.pacInputIcon),
      pacMessage = document.querySelector(selectors.pacMessage),
      result = document.querySelector(selectors.result),
      resultList = document.querySelector(selectors.resultList),
      selectedProductButton = document.querySelector(selectors.selectedProductButton);
      selectedProductLink = document.querySelector(selectors.selectedProductLink),
      selectedProductWrapper = document.querySelector(selectors.selectedProductWrapper),
      stockist = document.querySelector(selectors.stockist),
      stockistCount = document.querySelector(selectors.stockistCount);

// find stockist
function findStockists() {
  clearErrorMessage();
  let location = {};
  userOriginMarker.setVisible(false);

  if(localStorage.getItem('productStockis')) {
    const productStockisInforomation = JSON.parse(localStorage.getItem('productStockis'));

    location.lat = productStockisInforomation.lat;
    location.lng = productStockisInforomation.lng;
  }

  if (userPlace != null) {
    if (!userPlace.geometry) {
      showErrorMessage(selectors.errorGeometry);
      return;
    }
    else {
      location.lat = userPlace.geometry.location.lat();
      location.lng = userPlace.geometry.location.lng();
    }
  }
  else if (userLocation != null) {
    location.lat = userLocation.lat;
    location.lng = userLocation.lng;
  } else {
    showErrorMessage(selectors.errorMessage);
    return;
  }

  // Recenter the map to the selected address
  userMap.setCenter(location);
  userOriginMarker.setPosition(location);
  userOriginMarker.setVisible(true);
  getStockistsForLocation(userMap, userInfoWindow, location.lat, location.lng, form.dataset.brand);
}

// get user location from geolocation
function getUserLocation() {
  document.body.style.cursor = 'wait';

  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(function(position) {
      showPosition(position);
      document.body.style.cursor = 'default';
    },
    function(error) {
      if (error.code == error.PERMISSION_DENIED)
        showErrorMessage(selectors.errorGeolocation);
        document.body.style.cursor = 'default';
    });
  } else {
      showErrorMessage(selectors.errorBrowserGeolocation);
  }
}

// Create the map.
function initMap() {
  const map = new google.maps.Map(mapWrapper, {
      zoom: 6,
      center: { lat: 54.2181503, lng: -6.7915948 },
      disableDefaultUI: true,
      zoomControl: true,
      styles: mapStyle,
      clickableIcons: false
  })
  const apiKey = 'AIzaSyDdPT0odF20dreRXxQTw6DfcfEwK0eKJ6k',
        infoWindow = new google.maps.InfoWindow(),
        input = pacInput,
        options = { componentRestrictions: {country: ['gb', 'ie'] },},
        autocomplete = new google.maps.places.Autocomplete(input, options);

  autocomplete.setFields(['address_components', 'geometry', 'name']);

  const originMarker = new google.maps.Marker({
      position: { lat: 36.6163, lng: -100.6 },
          map,
          icon: userpin,
          title: "Material Icon Font Marker",
      });

  originMarker.setVisible(false);
  autocomplete.addListener('place_changed', async () => {
    clearErrorMessage();
      const place = autocomplete.getPlace();

      if (!place.geometry) {
        showErrorMessage(selectors.errorGeometry);
        return;
      }
      findStockistsButton.disabled = false;
      userPlace = place;
      userLocation = null;
      pacInputIcon.classList.remove(selectors.pacInputIconActiveClass);
      findStockists();
      return;
  });

  userAutocomplete = autocomplete;
  userMap = map;
  userOriginMarker = originMarker;
  userInfoWindow = infoWindow;

  if(localStorage.getItem('productStockis')) {
    showProductStockist();
  }

  if(localStorage.getItem('brandStockis')) {
    showBrandStockist();
  }
}

function showBrandStockist() {
  const information = JSON.parse(localStorage.getItem('brandStockis'));
  const myLatLng = { lat: information.lat, lng: information.lng };

  clearErrorMessage();
  pacInput.value = information.place;
  userLocation = myLatLng;
  userPlace = null;
  findStockists();
}

// get near stores
async function getStockistsForLocation(map, infoWindow, lat, lng, brand, bounds) {
  result.classList.remove(selectors.resultActiveClass);
  result.classList.add(selectors.resultLoadingClass);

  let target = "https://hoq4iah2gc.execute-api.eu-west-2.amazonaws.com/PROD/WestlandStockistsAPI?long=" + lng +"&lat=" + lat + "&brand=" + brand;

  window.dataLayer = window.dataLayer || [];

  if (localStorage.getItem('productStockis')) {
    const information = JSON.parse(localStorage.getItem('productStockis'));
    target = `https://hoq4iah2gc.execute-api.eu-west-2.amazonaws.com/PROD/WestlandStockistsAPI?long=${lng}&lat=${lat}&sku=${information.scu}`;
    window.dataLayer.push({
      'event': 'stockist_search',
      'type': 'product_all',
      'sku': information.scu,
      'title': information.name,
      'brand': brand,
      'location': pacInput.value
    });
  } else {
    window.dataLayer.push({
      'event': 'stockist_search',
      'type':  'all',
      'brand': brand,
      'location': pacInput.value
    });
  }
  try {
    let response = await fetch(target),
        responseText = await response.text();

    showStockistsOnMap(map, infoWindow, lat, lng, JSON.parse(responseText), bounds);
  } catch(err) {
    showErrorMessage(selectors.errorApiMessage);
    console.log(err);
  }
}

// change stockist display
function changeResultDisplay(button) {
  const currentClass = button.dataset.display;

  displayButton.forEach(element => {
    stockist.classList.remove(element.dataset.display);
  });

  stockist.classList.add(currentClass);
}

// show stores on the map
function showStockistsOnMap(map, infoWindow, lat, lng, stockists) {
  let markerBounds = new google.maps.LatLngBounds();

  markerBounds.extend({ lat: lat, lng: lng });
  userInfoWindow.close();
  userStockists = stockists;

  if (userMarkers != null && userMarkers.length > 0) {
    for (i = 0; i < userMarkers.length; i++) {
        userMarkers[i].setMap(null);
    }
  }

  userMarkers = [];
  resultList.innerHTML = '';

  for (i = 0; i < stockists.length; i++) {
    const name = stockists[i].stockist_name;
    const distance = stockists[i].stockist_distance_miles > 10 ? Math.round(stockists[i].stockist_distance_miles) + " Miles" : stockists[i].stockist_distance_miles + " Miles";
    var address1 = stockists[i].stockist_address_1;
    if (stockists[i].stockist_address_2) {
      address1 += ", " + stockists[i].stockist_address_2;
    }
    const city = stockists[i].stockist_address_city;
    const county = stockists[i].stockist_address_county;
    const postcode = stockists[i].stockist_address_postalcode;
    const phone = stockists[i].stockist_telephone;
    const position = { lat: stockists[i].stockist_latitude, lng: stockists[i].stockist_longitude };
    
    let address2 = city;
    if (city && county) {
      address2 += ', ' + county;
    } else if (county) {
      address2 = county;
    }
    const content = `
    <div class="stockistCard stockist-card">
        <h3 class="stockistCard__header">
        <span class="stockistCard__headerTitle">
          ${name}
        </span>
        <span class="stockistCard__headerDistance">
          ${distance}
        </span>
        </h3>
        <div class="stockistCard__info stockist-card-info">
            <div class="stockist-card-address">
                <p>${address1}</p>
                <p>${address2}</p>
                <p>${postcode}</p>
            </div>
            <div class="stockistCard__contact stockist-card-phone">
              ${phone != '' ? `<p class="stockistCard__contactPhone">TEL: ${phone}</p>` : '' }
                <p class="stockistCard__contactLinkWrapper">
                  <a class="stockistCard__contactLink" target="_blank" href="https://www.google.com/maps/dir/?api=1&origin=${lat},${lng}&destination=${position.lat},${position.lng}">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <mask id="mask0_1864_1502" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                        <rect x="0.5" y="0.5" width="19" height="19" fill="#D9D9D9" stroke="#E3E3E3"/>
                      </mask>
                      <g mask="url(#mask0_1864_1502)">
                        <path d="M8.5 9.5H8V10V11.5H7.5V9.25C7.5 9.17351 7.5211 9.12401 7.57255 9.07255C7.62401 9.0211 7.67351 9 7.75 9H11H11.5V8.5V7.95711L12.7929 9.25L11.5 10.5429V10V9.5H11H8.5ZM9.61772 17.4294L9.61714 17.4292C9.50963 17.3879 9.40117 17.3185 9.29232 17.2092L9.29155 17.2084L2.79155 10.7084L2.79078 10.7077C2.68145 10.5988 2.61207 10.4904 2.57081 10.3829L2.57058 10.3823C2.52355 10.2602 2.5 10.1338 2.5 10C2.5 9.86621 2.52355 9.73984 2.57058 9.61772L2.57081 9.61714C2.61207 9.50963 2.68145 9.40117 2.79078 9.29232L2.79155 9.29155L9.29155 2.79155L9.29232 2.79078C9.40117 2.68145 9.50963 2.61207 9.61714 2.57081L9.61772 2.57058C9.73984 2.52355 9.86621 2.5 10 2.5C10.1338 2.5 10.2602 2.52355 10.3823 2.57058L10.3829 2.57081C10.4904 2.61207 10.5988 2.68145 10.7077 2.79078L10.7084 2.79155L17.2084 9.29155L17.2092 9.29232C17.3185 9.40117 17.3879 9.50963 17.4292 9.61714L17.4294 9.61772C17.4765 9.73984 17.5 9.86621 17.5 10C17.5 10.1338 17.4765 10.2602 17.4294 10.3823L17.4292 10.3829C17.3879 10.4904 17.3185 10.5988 17.2092 10.7077L17.2084 10.7084L10.7084 17.2084L10.7077 17.2092C10.5988 17.3185 10.4904 17.3879 10.3829 17.4292L10.3823 17.4294C10.2602 17.4765 10.1338 17.5 10 17.5C9.86621 17.5 9.73984 17.4765 9.61772 17.4294ZM9.64645 16.8536L10 17.2071L10.3536 16.8536L16.8536 10.3536L17.2071 10L16.8536 9.64645L10.3536 3.14645L10 2.79289L9.64645 3.14645L3.14645 9.64645L2.79289 10L3.14645 10.3536L9.64645 16.8536Z" fill="#00522B" stroke="#E3E3E3"/>
                      </g>
                    </svg>
                    Directions
                  </a>
                </p>
            </div>
        </div>
    </div>
    `;

    // show result in list
    createResultCard(content, i, name);

    let marker= new google.maps.Marker({
        position: { lat: stockists[i].stockist_latitude, lng: stockists[i].stockist_longitude },
        map,
        title: stockists[i].stockist_name,
        icon: stockistPins[i],
        content: content,
        num: i
        });

    markerBounds.extend(marker.position);
    marker.addListener('click', (event) => {
      checkCard(marker);

      if (userSelectedMarker) {
        userSelectedMarker.setIcon(stockistPins[userSelectedMarker.num]);
      }

      userSelectedMarker = marker;
      marker.setIcon(stockistPinsSelected[marker.num]);
      userInfoWindow.setContent(content);
      userInfoWindow.setPosition(position);
      userInfoWindow.setOptions({pixelOffset: new google.maps.Size(0, -30)});
      userInfoWindow.open(map, marker);
      userMap.panTo(marker.getPosition());
    });
    userMarkers.push(marker);
  }

  result.classList.remove(selectors.resultLoadingClass);
  result.classList.add(selectors.resultActiveClass);
  stockistCount.innerHTML = stockists.length;
  userMap.fitBounds(markerBounds);
}

// create result card
function createResultCard(content, number, name) {
  const resultCard = document.createElement('div');
  resultCard.setAttribute('data-marker', name);
  resultCard.className = selectors.resultListCardClass
  const resultCardCount = `<div class="${selectors.resultListCardCountClass}">${number + 1}</div>`;

  resultCard.addEventListener('click', (e) => {
    checkMarker(e.currentTarget);
  })
  resultCard.insertAdjacentHTML("beforeend", resultCardCount);
  resultCard.insertAdjacentHTML("beforeend", content);
  resultList.insertAdjacentElement('beforeend', resultCard);
}

// check marker
function checkMarker(card) {
  const cardArray = document.querySelectorAll(selectors.resultListCard),
        currentMarker = mapWrapper.querySelector(`[title*="${card.dataset.marker}"]`);

  if(currentMarker) {
    cardArray.forEach(element => {
      element.classList.remove(selectors.resultListCardActiveClass);
    });
    card.classList.add(selectors.resultListCardActiveClass);
    currentMarker.click();
  }
}

// check card
function checkCard(marker) {
  const cardArray = document.querySelectorAll(selectors.resultListCard),
        currentCard = document.querySelector(`[data-marker*="${marker.title}"]`);

  if (currentCard) {
    cardArray.forEach(element => {
      element.classList.remove(selectors.resultListCardActiveClass);
    });

    if (window.innerWidth > 768) {
      currentCard.scrollIntoView({block: "end", inline: "nearest"});
    }

    currentCard.classList.add(selectors.resultListCardActiveClass);
  }
}

// show use position on the map
function showPosition(position) {
  clearErrorMessage();
  const myLatLng = { lat: position.coords.latitude, lng: position.coords.longitude };
  pacInput.value = selectors.geoLocationTitle;
  pacInputIcon.classList.add(selectors.pacInputIconActiveClass);
  userLocation = myLatLng;
  userPlace = null;
  findStockistsButton.disabled = false;
}

// show error block and message
function showErrorMessage(msg) {
  pacError.innerHTML = msg;
  stockist.classList.add(selectors.stockistErrorClass);
}

// clear error message and block
function clearErrorMessage() {
  pacError.innerHTML = '';
  stockist.classList.remove(selectors.stockistErrorClass);
}

// show Product Stockist
function showProductStockist() {
  const information = JSON.parse(localStorage.getItem('productStockis'));
  const myLatLng = { lat: information.lat, lng: information.lng };

  clearErrorMessage();
  pacInput.value = information.place;
  userLocation = myLatLng;
  userPlace = null;
  fillProductInformation(information);
  findStockists();
}

// fill product wrapper infromation
function fillProductInformation(data) {
  selectedProductLink.setAttribute('href', data.url);
  selectedProductLink.innerText = data.name;
  selectedProductWrapper.classList.add(selectors.selectedProductWrapperActiveClass);
}

// clear search trought product
function clearProductStockist() {
  localStorage.removeItem('productStockis');
  selectedProductWrapper.classList.remove(selectors.selectedProductWrapperActiveClass);
  clearSearch();
}

//  clear search
function clearSearch() {
  result.classList.remove(selectors.resultActiveClass);
  pacInputIcon.classList.remove(selectors.pacInputIconActiveClass);
  stockist.classList.remove(selectors.stockistMapClass);
  stockist.classList.add(selectors.stockistListClass);
  pacInput.value = '';
  initMap();
}

//  claer input
function clearInput() {
  findStockistsButton.disabled = true;
  pacInput.value = '';
  pacInputIcon.classList.remove(selectors.pacInputIconActiveClass);
  userLocation = null;
}

// add Event listeners
pacInputIcon.addEventListener('click', getUserLocation);
form.addEventListener('submit', (e) => {
  e.preventDefault();
  if (pacInput.value == "") {
    showErrorMessage(selectors.errorAutocomplete);
    return
  }
});
findStockistsButton.addEventListener('click', findStockists);
selectedProductButton.addEventListener('click', clearProductStockist);
pacInput.addEventListener('click', clearInput);
displayButton.forEach(element => {
  element.addEventListener('click', (e) => {
    changeResultDisplay(e.currentTarget);
  })
});
